import { StateCreator } from 'zustand';
import { StoreSlices } from '.';

export interface SettingsOverridesProps {
  componentStyles: any[];
  globals: any[];
  themeSettings: any[];
}

export interface SettingsOverrideSlice extends SettingsOverridesProps {
  setSettingsOverrides: (settingsOverride: any) => void;
}
export const createSettingsOverrideSlice =
  (
    initProps?: Partial<SettingsOverridesProps>,
  ): StateCreator<
    Partial<StoreSlices>,
    [['zustand/devtools', never], ['zustand/immer', never]],
    [],
    SettingsOverrideSlice
  > =>
  (set: any, get: any, api: any) => {
    return {
      componentStyles: initProps?.componentStyles ?? [],
      globals: initProps?.globals ?? [],
      themeSettings: initProps?.themeSettings ?? [],
      setSettingsOverrides: (settingsOverrides: any[]) =>
        set(
          { settingsOverrides },
          undefined,
          'settingsOverrides/setSettingsOverrides',
        ),
    };
  };
